import { ChangeDetectorRef, Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { REGION_CATEGORY_IMAGE_LIST } from '../customers/marketplace/marketplace.model';
import { AuthServiceService } from '../shareModule/services/auth-service.service';
import { ApiResponse } from '../shareModule/models/common.model';
import { environment } from 'src/environments/environment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-select-region',
  templateUrl: './select-region.component.html',
  styleUrl: './select-region.component.scss',
})
export class SelectRegionComponent implements OnInit {
  public regionCategoryImageList: Array<any> = REGION_CATEGORY_IMAGE_LIST;
  public selectedRegionForCategoryPopup = '';
  public nonUploadBaseUrl = '../../../../../assets/images/shop/';

  @Input()
  public set selectOnlyOne(value){
    //console.log('setting selectOnlyOne to', value)
    this._selectOnlyOne = value;
    this.cdr.detectChanges()
  }

  public get selectOnlyOne(){
    return this._selectOnlyOne
  }

  private _selectOnlyOne = false;

  carouselWithNavOptions: any = {
    spaceBetween: 0,
    slidesPerView: 'auto',
    pagination: false,
  };
  carouselWithNavOptions2: any = {
    spaceBetween: 2,
    slidesPerView: 'auto',
    // loop: true,
    pagination: false,
    grid: {
      rows: this.window.innerWidth > 500 ? 1 : 2,
      fill: 'row',
    },
  };
  public selecteMemberShopSubCategory: any = '';

  public memberShopCategoriesList = []
  constructor(
    private cdr: ChangeDetectorRef,
    private auth: AuthServiceService,
    @Optional() private activeModal: NgbActiveModal,
    @Optional() private activeBottomSheet: MatBottomSheet,
    @Inject('WINDOW') private window: any,
  ) {
    this.modal = activeModal || activeBottomSheet
  }

  public modal = null

  ngOnInit(): void {
    this._fetchSubRegions();
  }
  handleError(event: any): void {
    (event.target as HTMLImageElement).src =
      '../../../../assets/images/shop/default.png';
  }

  public closeWithResult(){
    this.activeModal.close(this.selectedSubRegions)
  }
  
  public selectedSubRegions = []
  public subRegionButtonClicked(r) {
    if(this.selectOnlyOne){
      this.activeModal.close(r);
    }else{
      //console.log({r})
       const storedSubRegionIndex = this.selectedSubRegions.findIndex(sub => sub.subRegionId == r.subRegionId)
      if(storedSubRegionIndex == -1){
       // console.log('subregion not found adding')
        this.selectedSubRegions.push(r)
      }
      else{
         //console.log('subregion  found removing')
        this.selectedSubRegions.splice(storedSubRegionIndex, 1)
      }

    }
   
  }
  public closeActiveModal() {
    this.activeModal?.dismiss();
    this.activeBottomSheet?.dismiss();
  }

  public setCurrentRegion(region) {
    this.currentFilteredSubregions = this.bottomSubregions
      .filter((sub) => sub.regionName == region.name)
      .map((sub) => {
        return { ...sub, checked: false };
      });
   // console.log('filtered sub regions', this.currentFilteredSubregions);
    this.cdr.detectChanges();
  }
  public bottomSubregions = [];
  private _fetchSubRegions() {
    this.auth.getMemberShopSubRegion().subscribe((resp: ApiResponse) => {
      this.bottomSubregions = resp.body.map((sub) => {
        return { ...sub, checked: false };
      });
      this.cdr.detectChanges();
    });
  }
  public currentFilteredSubregions = [];
}
